import { render, staticRenderFns } from "./AnswerlList.vue?vue&type=template&id=0f9aeba4&scoped=true&"
import script from "./AnswerlList.vue?vue&type=script&lang=ts&"
export * from "./AnswerlList.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerlList.vue?vue&type=style&index=0&id=0f9aeba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9aeba4",
  null
  
)

export default component.exports